// FETCH ALL BILL PAYMENT
export const FETCH_BILL_PAYMENT_MASTER_REQUEST = 'FETCH_BILL_PAYMENT_MASTER_REQUEST';
export const FETCH_BILL_PAYMENT_MASTER_SUCCESS = 'FETCH_BILL_PAYMENT_MASTER_SUCCESS';
export const FETCH_BILL_PAYMENT_MASTER_FAILURE = 'FETCH_BILL_PAYMENT_MASTER_FAILURE';

export const FETCH_BILL_PAYMENT_SUPPLIER_MASTER_REQUEST = 'FETCH_BILL_PAYMENT_SUPPLIER_MASTER_REQUEST';
export const FETCH_BILL_PAYMENT_SUPPLIER_MASTER_SUCCESS = 'FETCH_BILL_PAYMENT_SUPPLIER_MASTER_SUCCESS';
export const FETCH_BILL_PAYMENT_SUPPLIER_MASTER_FAILURE = 'FETCH_BILL_PAYMENT_SUPPLIER_MASTER_FAILURE';

// FETCH ALL BILL PAYMENT
export const FETCH_PENDING_BILL_PAYMENT_MASTER_REQUEST = 'FETCH_PENDING_BILL_PAYMENT_MASTER_REQUEST';
export const FETCH_PENDING_BILL_PAYMENT_MASTER_SUCCESS = 'FETCH_PENDING_BILL_PAYMENT_MASTER_SUCCESS';
export const FETCH_PENDING_BILL_PAYMENT_MASTER_FAILURE = 'FETCH_PENDING_BILL_PAYMENT_MASTER_FAILURE';

// CREATE BILL PAYMENT
export const CREATE_BILL_PAYMENT_MASTER_REQUEST = 'CREATE_BILL_PAYMENT_MASTER_REQUEST';
export const CREATE_BILL_PAYMENT_MASTER_SUCCESS = 'CREATE_BILL_PAYMENT_MASTER_SUCCESS';
export const CREATE_BILL_PAYMENT_MASTER_FAILURE = 'CREATE_BILL_PAYMENT_MASTER_FAILURE';

// UPDATE BILL PAYMENT
export const UPDATE_BILL_PAYMENT_MASTER_REQUEST = 'UPDATE_BILL_PAYMENT_MASTER_REQUEST';
export const UPDATE_BILL_PAYMENT_MASTER_SUCCESS = 'UPDATE_BILL_PAYMENT_MASTER_SUCCESS';
export const UPDATE_BILL_PAYMENT_MASTER_FAILURE = 'UPDATE_BILL_PAYMENT_MASTER_FAILURE';

// FETCH SINGLE STATE OF BILL PAYMENT
export const FETCH_SINGLE_BILL_PAYMENT_MASTER_REQUEST = 'FETCH_SINGLE_BILL_PAYMENT_MASTER_REQUEST';
export const FETCH_SINGLE_BILL_PAYMENT_MASTER_SUCCESS = 'FETCH_SINGLE_BILL_PAYMENT_MASTER_SUCCESS';
export const FETCH_SINGLE_BILL_PAYMENT_MASTER_FAILURE = 'FETCH_SINGLE_BILL_PAYMENT_MASTER_FAILURE';

// DELETE BILL PAYMENT
export const DELETE_BILL_PAYMENT_MASTER_REQUEST = 'DELETE_BILL_PAYMENT_MASTER_REQUEST';
export const DELETE_BILL_PAYMENT_MASTER_SUCCESS = 'DELETE_BILL_PAYMENT_MASTER_SUCCESS';
export const DELETE_BILL_PAYMENT_MASTER_FAILURE = 'DELETE_BILL_PAYMENT_MASTER_FAILURE';

// FETCH ALL BILL PAYMENT
export const GENERATE_MULTIPLE_BILL_PAYMENT_MASTER_REQUEST = 'GENERATE_MULTIPLE_BILL_PAYMENT_MASTER_REQUEST';
export const GENERATE_MULTIPLE_BILL_PAYMENT_MASTER_SUCCESS = 'GENERATE_MULTIPLE_BILL_PAYMENT_MASTER_SUCCESS';
export const GENERATE_MULTIPLE_BILL_PAYMENT_MASTER_FAILURE = 'GENERATE_MULTIPLE_BILL_PAYMENT_MASTER_FAILURE';

export const CREATE_MULTIPLE_BILL_PAYMENT_REQUEST = 'CREATE_MULTIPLE_BILL_PAYMENT_REQUEST';
export const CREATE_MULTIPLE_BILL_PAYMENT_SUCCESS = 'CREATE_MULTIPLE_BILL_PAYMENT_SUCCESS';
export const CREATE_MULTIPLE_BILL_PAYMENT_FAILURE = 'CREATE_MULTIPLE_BILL_PAYMENT_FAILURE';

export const RESET_BILL_PAYMENT_MASTER_INFO = 'RESET_BILL_PAYMENT_MASTER_INFO';

export const CREATE_BILL_PAYMENT_MASTER_FORM = 'CREATE_BILL_PAYMENT_MASTER_FORM';

export const UPDATE_BILL_PAYMENT_MASTER_FORM = 'UPDATE_BILL_PAYMENT_MASTER_FORM';

// NAVIGATE TO BILL_PAYMENT DETAILS COMPONENT
export const NAVIGATE_BILL_PAYMENT_DETAILS = 'NAVIGATE_BILL_PAYMENT_DETAILS';

// NAVIGATE TO BILL PAYMENT COMPONENT
export const NAVIGATE_BILL_PAYMENT_MASTER = 'NAVIGATE_BILL_PAYMENT_MASTER';

export const RESET_FORM_DATA_WITHOUT_INWARD_ID_DK = 'RESET_FORM_DATA_WITHOUT_INWARD_ID_DK';
export const SET_ACTIVE_KEY_BILL_PAYMENT_INWARD_DK = 'SET_ACTIVE_KEY_BILL_PAYMENT_INWARD_DK';
